export const SystemOptionType = {
  CATEGORY: 'category',
  SECTION: 'section',
  ARTICLE: 'article',
} as const;

export type SystemOptionKind = (typeof SystemOptionType)[keyof typeof SystemOptionType];
